module.exports = __webpack_public_path__ + "assets/img/1a6b8401c75ab1e9d7861ef72e888904.svg";